import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { WarehouseHandlingModal } from '../../models/warehose-handling-modal';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { LoggerService } from 'src/app/services/logger.service';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { TabelPaging } from '../../interfaces/table';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { PCTableActionInputModel } from '../../models/pc-table-action-input-model';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash-es';
import {
  ImportWarehouseHandlingDetailModal,
  WarehouseHandlingDetailItem,
  WarehouseHandlingDetailModal,
} from '../../models/warehose-handling-detail-modal';
import { Router } from '@angular/router';
import { ModalConfirm } from '../../models/modal-confirm';
import { NumericService } from 'src/app/services/numeric.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PCTableComponent } from '../../components/pctable/pctable.component';
import { PcsettingModalComponent } from '../../components/pcsetting-modal/pcsetting-modal.component';
import { NewCalendarService } from 'src/app/services/new-calender-service';
import { BarcodeService } from 'src/app/services/barcode.service';
import { BarcodeScannerComponent } from '../../components/barcode-scanner/barcode-scanner.component';

declare var bootstrap: any;

@Component({
  selector: 'app-warehouse-handling-detail',
  templateUrl: './warehouse-handling-detail.component.html',
  styleUrls: ['./warehouse-handling-detail.component.css'],
})
export class WarehouseHandlingDetailComponent {
  @ViewChild('calculateModal') calculateModal!: NgbPopover;
  @ViewChild('reconciliationModal') reconciliationModal!: NgbPopover;
  @ViewChild('datePicker') public popoverDataPicker!: NgbPopover;
  @ViewChild('newModal') newModal!: NgbPopover;
  @ViewChild(PCTableComponent) pcTableComponent!: PCTableComponent;
  @ViewChild('collapseDiv') collapseDiv!: ElementRef;
  @ViewChild(PcsettingModalComponent)
  pcsettingModalComponent!: PcsettingModalComponent;

  public endPoint: string = `WarehouseHandling`;
  public endPointUrl!: string;
  public requestModel: PCSearchRequestModel;
  public action: PCTableActionInputModel;
  public fields: any[] = [];
  public breadCrumb: string = '';
  public monthName: string = '';
  public activeMinus: boolean = false;

  public data?: PCTableInputModel;
  public paging?: TabelPaging;

  public detailData?: PCTableInputModel;
  public detailpaging?: TabelPaging;

  public loading: boolean = false;
  public modalSuccessConfirm: boolean = false;
  public modalDeleteConfirm: boolean = false;
  public modalLoading: boolean = false;
  public fastCounter: boolean = false;

  public selectValue: ImportWarehouseHandlingDetailModal;
  public valueList: ImportWarehouseHandlingDetailModal[] = [];
  public searchBarcode: string | undefined;
  public alarmMessage: string = '';

  public barcode?: string;

  public counterLevel: number = 1;

  public confirmModal: ModalConfirm = new ModalConfirm(
    'warning',
    'ConfirmStopWarehouseHandlingMessage',
    'Finish',
    'AcceptFinishWarehouseHandling',
    'DenyFinishWarehouseHandling'
  );

  constructor(
    private modalService: NgbModal,
    private logger: LoggerService,
    private route: Router,
    public numericService: NumericService,
    private responseService: CustomizeResponseService,
    private apiService: UserApiService,
    public calendarService: NewCalendarService,
    private barcodeService: BarcodeService
  ) {
    this.requestModel = new PCSearchRequestModel();
    this.requestModel.orderBy = '';
    this.requestModel.direction = '';
    this.action = new PCTableActionInputModel(
      [
        {
          name: 'FinishWarehouseHandling',
          className: 'btn-outline-warning',
          icon: 'far fa-stop-circle',
        },
        {
          name: 'FastWarehousingHandling',
          className: 'btn-outline-primary',
          icon: 'fas fa-shipping-fast',
        },
        {
          name: 'Reload',
          className: 'btn-outline-primary',
          icon: 'bx bx-refresh',
        },
        {
          name: 'Settings',
          className: 'btn-outline-primary',
          icon: 'bx bx-cog',
        },
        {
          name: 'Print',
          className: 'btn-outline-primary',
          icon: 'bx bx-printer',
        },
        {
          name: 'Return-Page',
          className: 'btn-outline-primary',
          icon: 'fa-solid fa-reply',
        },
      ],
      '',
      []
    );

    this.selectValue = new ImportWarehouseHandlingDetailModal(null);
  }

  isCollapseShown = false;
  collapseInstance: any;

  @ViewChild('barcodeScanner') barcodeScanner!: BarcodeScannerComponent;
  @Output() outputParentAction = new EventEmitter<PCTableOutputModel>();
  public pageLoaded: boolean = false;
  public cardClass: string = 'animate__backInDown';
  public thisWarehouseHandling?: WarehouseHandlingModal;

  public InitPage(warehouseHandling: WarehouseHandlingModal) {
    this.loading = true;
    this.cardClass = 'animate__backInDown';
    this.pageLoaded = true;
    this.thisWarehouseHandling = warehouseHandling;
    this.breadCrumb = `${this.breadCrumb},${warehouseHandling.stockName}`;
    forkJoin([this.getData(), this.getEntity()]).subscribe(
      ([dataResult, entityResult]) => {
        if (dataResult) {
          this.logger.addResponseLog(this.endPointUrl, dataResult, `Get All`);
          if (dataResult.succeeded) {
            let firstItemOnPage = 1;
            if (dataResult.data?.firstItemOnPage) {
              firstItemOnPage = dataResult.data?.firstItemOnPage;
            }

            if (dataResult.data?.pageCount! < dataResult.data?.pageNumber! && dataResult.data?.pageCount!=0) {
              this.requestModel.pageNumber = 1;
              this.getSingleData();
            }

            this.data = new PCTableInputModel(
              dataResult.data?.items,
              [
                {
                  name: 'Counting',
                  className: 'btn-outline-primary',
                  icon: 'bx bxs-calculator',
                },
                // {
                //   name: 'RecountingButton',
                //   className: 'btn-outline-warning',
                //   icon: 'fas fa-refresh',
                // },
              ],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.paging = this.responseService.customizePaging(dataResult);

            setTimeout(() => {
              let selectStockPage = document.getElementById('selectStockPage');
              if (selectStockPage) {
                selectStockPage.classList.remove('animate__backInDown');
              }
            }, 2 * 1000);
          } else {
            this.logger.addBackEndMessage(dataResult);
          }
        }

        if (entityResult) {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            entityResult,
            `Get Entity`
          );
          if (entityResult.succeeded) {
            let fields = this.apiService.convertStringToBoolean(
              entityResult.data.fields
            );

            fields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            this.fields = fields;
          }
        }

        setTimeout(() => {
          if (this.pcTableComponent) {
            this.pcTableComponent.InitPage();
          } else {
            console.error('PCTableComponent not found');
          }
        }, 2);

        setTimeout(() => {
          let selectStockPage = document.getElementById('selectStockPage');
          if (selectStockPage) {
            selectStockPage.classList.remove('animate__backInDown');
          }
        }, 2000);

        this.loading = false;
      },
      (error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
      }
    );
  }

  public changeStatus() {
    this.activeMinus = !this.activeMinus;
    this.calcCounting(true);
  }

  public calcCounting(changePackage: boolean) {
    if (this.selectValue == null) {
      return;
    }

    this.alarmMessage = '';
    if (changePackage) {
      if (
        this.selectValue.drugPackageCount == null ||
        this.selectValue.drugPackageCount.toString() == ''
      ) {
        this.selectValue.drugPackageCount = 1;
      }
      if (
        this.selectValue.countingDrugPackage == null ||
        this.selectValue.countingDrugPackage.toString() == ''
      ) {
        this.selectValue.countingDrugPackage = 0;
      }

      this.selectValue.countingWarehouseHandlingCount =
        this.selectValue.drugPackageCount *
        this.selectValue.countingDrugPackage;
    }

    if (this.activeMinus) {
      if (
        this.selectValue.count < this.selectValue.countingWarehouseHandlingCount
      ) {
        this.selectValue.countingWarehouseHandlingCount =
          this.selectValue.count;
        this.alarmMessage = 'countdown_greater_original';
      }
      this.selectValue.countingFinalCount =
        this.selectValue.warehouseHandlingCount -
        this.selectValue.countingWarehouseHandlingCount;
    } else {
      this.selectValue.countingFinalCount =
        this.selectValue.warehouseHandlingCount +
        this.selectValue.countingWarehouseHandlingCount;
    }
    if (this.selectValue.countingFinalCount < 0) {
      this.selectValue.countingAdjustment =
        this.selectValue.count + this.selectValue.countingFinalCount;
    } else {
      this.selectValue.countingAdjustment =
        this.selectValue.count - this.selectValue.countingFinalCount;
    }
  }

  public changeMonth(val: string) {
    if (this.popoverDataPicker.isOpen()) {
      this.popoverDataPicker.close();
    }
    this.monthName = val;
  }

  public ClosePage() {
    this.cardClass = 'animate__backOutDown';
    setTimeout(() => {
      this.cardClass = '';
      this.pageLoaded = false;
    }, 1000);
  }

  public getData() {
    const url = `${this.endPoint}/WarehouseHandlingDetail/${this.thisWarehouseHandling?.stockId}?pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}&search=${this.requestModel.search}`;
    return this.apiService.getAll(new ApiRequestModel(url)).pipe(
      catchError((error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
        return of(null);
      })
    );
  }

  public getSingleData() {
    try {
      this.loading = true;
      const url = `${this.endPoint}/WarehouseHandlingDetail/${this.thisWarehouseHandling?.stockId}?pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}&search=${this.requestModel.search}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (
              result.data?.pageCount! < result.data?.pageNumber! &&
              result.data?.pageCount != 0
            ) {
              this.requestModel.pageNumber = 1;
              this.getSingleData();
            }

            this.data = new PCTableInputModel(
              result.data?.items,
              [
                {
                  name: 'Counting',
                  className: 'btn-outline-primary',
                  icon: 'bx bxs-calculator',
                },
              ],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            const matTable = document.querySelector('.table-responsive');
            if (matTable != null) {
              matTable.scrollTop = 0;
            }

            this.paging = this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public getEntity() {
    return this.apiService
      .getEntity(
        new ApiRequestModel(
          this.endPoint,
          null,
          undefined,
          this.endPoint,
          'WarehouseHandlingDetail'
        )
      )
      .pipe(
        catchError((error) => {
          this.apiService.AddErrorLog(error);
          return of(null);
        })
      );
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.loading = true;
        if (this.requestModel.orderBy == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.orderBy != event.data) {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == 'asd') {
          this.requestModel.direction = 'desc';
        }

        this.requestModel.orderBy = event.data;

        this.getSingleData();
        break;
      case 'Search':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.search = event.data;
        this.getSingleData();
        break;
      case 'Paging':
        this.loading = true;

        this.requestModel.pageNumber = event.data;
        this.getSingleData();
        break;
      case 'PageSize':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.pageSize = event.data;
        this.getSingleData();
        break;
      case 'Reload':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.getSingleData();
        break;
      case 'Close':
        break;
      case 'Successed':
        this.modalSuccessConfirm = false;
        break;
      case 'Counting':
        this.fastCounter = false;
        this.valueList = [];
        this.selectValue = new ImportWarehouseHandlingDetailModal(event.data);
        this.activeMinus = false;
        this.openModal(this.newModal);
        break;
      case 'FastWarehousingHandling':
        const data = {
          stockId: this.thisWarehouseHandling?.stockId,
          id: this.thisWarehouseHandling?.id,
        };
        this.outputParentAction.next(
          new PCTableOutputModel('FastWarehousingHandling', data)
        );
        break;
      case 'Return-Page':
        this.outputParentAction.next(
          new PCTableOutputModel('Return', undefined)
        );
        break;

      case 'FinishWarehouseHandling':
        this.modalDeleteConfirm = true;
        this.confirmModal = new ModalConfirm(
          'warning',
          'ConfirmStopWarehouseHandlingMessage',
          'Finish',
          'AcceptFinishWarehouseHandling',
          'DenyFinishWarehouseHandling'
        );
        break;

      case 'DenyFinishWarehouseHandling':
        this.modalDeleteConfirm = false;
        break;

      case 'AcceptFinishWarehouseHandling':
        this.finishingWarehouseHandling();
        break;

      // case 'RecountingButton':
      //   this.modalDeleteConfirm = true;
      //   this.selectValue = this.convertDataToModel(event.data);
      //   this.calcCounting();
      //   this.confirmModal = new ModalConfirm(
      //     'warning',
      //     'ConfirmRecountingButtonMessage',
      //     'Recounting',
      //     'AcceptRecountingButton',
      //     'DenyRecountingButton'
      //   );
      //   break;

      // case 'AcceptRecountingButton':
      //   this.modalDeleteConfirm = false;
      //   this.recounting(this.selectValue?.id);
      //   break;

      // case 'DenyRecountingButton':
      //   this.modalDeleteConfirm = false;
      //   break;

      case 'Settings':
        this.pcsettingModalComponent.openSettingModal();
        break;
      case 'SubmitSetting':
        this.fields = event.data;
        if (this.pcTableComponent) {
          this.pcTableComponent.RebuildColumn();
        } else {
          console.error('PCTableComponent not found');
        }
        break;
      default:
        break;
    }
  }

  public openModal(content: any) {
    try {
      this.modalService
        .open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
            }
          },
          (reason) => {}
        );
    } catch (error) {}
  }

  public clearSelect() {
    this.searchBarcode = undefined;
    this.selectValue = new ImportWarehouseHandlingDetailModal(null);
    this.valueList = [];
    this.calcCounting(true);
    this.closeCollapseJS();
  }

  public advanceSearch() {
    try {
      if (this.searchBarcode == null) {
        this.openCamera();
        return;
      }
      const url = `${this.endPoint}/WarehouseHandlingDetail/Search/${this.thisWarehouseHandling?.stockId}?barCode=${this.searchBarcode}`;
      const expireDate = this.barcodeService.ToExpireDate(this.searchBarcode);
      if (expireDate != null) {
        this.selectValue.expireDate = expireDate;
      }

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        this.clearSelect();
        return;
      }

      this.modalLoading = true;
      this.counterLevel = 1;

      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            switch (result.data.length) {
              case undefined:
                this.alarmMessage = 'Error_In_Scan';

                this.clearSelect();
                this.closeCollapseJS();
                break;
              case 0:
                this.alarmMessage = 'Error_In_Scan';

                this.clearSelect();
                this.closeCollapseJS();
                break;
              case 1:
                this.selectValue = new ImportWarehouseHandlingDetailModal(
                  result.data[0]
                );
                if (expireDate != null) {
                  this.selectValue.expireDate = expireDate;
                }
                this.calcCounting(true);
                this.valueList = [];
                this.closeCollapseJS();
                break;
              default:
                const inventory = result.data.filter(
                  (current) => current.expireDate != null
                );
                if (inventory.length == 1) {
                  this.selectValue = new ImportWarehouseHandlingDetailModal(
                    result.data[0]
                  );
                } else {
                  this.selectValue = new ImportWarehouseHandlingDetailModal(
                    null
                  );
                  if (expireDate != null) {
                    this.selectValue.expireDate = expireDate;
                  }
                }
                this.calcCounting(true);
                this.valueList = result.data;
                this.openCollapseJS();
                break;
            }
          } else {
            this.logger.addBackEndMessage(result);
            this.clearSelect();
          }
          this.barcode = undefined;
          this.modalLoading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.modalLoading = false;
          this.clearSelect();
        },
        () => {
          this.modalLoading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.modalLoading = false;
      this.clearSelect();
    }
  }

  public selectAnotherDrug(drug: ImportWarehouseHandlingDetailModal) {
    const expireDate = _.cloneDeep(this.selectValue.expireDate);
    this.selectValue = _.cloneDeep(drug);
    if (expireDate != null) {
      this.selectValue.expireDate = _.cloneDeep(expireDate);
    }
    this.calcCounting(true);
  }

  public getRowClassName(drug: ImportWarehouseHandlingDetailModal): string {
    if (drug.inventoryDetailId == null) {
      if (this.selectValue.inventoryDetailId == null) {
        if (drug.drugId == this.selectValue.drugId) {
          return 'warning-row';
        }
      }
      return 'danger-row';
    } else {
      if (drug.inventoryDetailId == this.selectValue.inventoryDetailId) {
        return 'primary-row';
      } else {
        return 'success-row';
      }
    }
  }

  private openCamera() {
    this.barcodeScanner.openPopup();
  }

  handleScannedBarcode(event: PCTableOutputModel) {
    this.searchBarcode = event.data;
    this.advanceSearch();
  }

  public smartCount() {
    try {
      if (this.selectValue == null) {
        this.alarmMessage = 'WarehouseHandlingNotSelectError';
        return;
      }

      if (this.selectValue.countingWarehouseHandlingCount == null) {
        this.alarmMessage = 'WarehouseHandlingNotCountError';
        return;
      }

      if (this.selectValue.countingWarehouseHandlingCount == 0) {
        this.alarmMessage = 'countOfDrugsNotNegativeOnDrugError';
        return;
      }

      if (
        this.thisWarehouseHandling == null ||
        this.thisWarehouseHandling.id == null
      ) {
        this.alarmMessage = 'WarehouseHandlingNotFoundWarehouseIdError';
        return;
      }

      if (this.selectValue.expireDate == null) {
        this.alarmMessage = 'ExpireDateIsRequired';
        return;
      }

      let trueCountValue = this.selectValue.countingWarehouseHandlingCount;
      if (this.activeMinus) {
        trueCountValue *= -1;
      }

      const backEndJson = {
        count: trueCountValue,
        warehouseHandlingId: this.thisWarehouseHandling.id,
        inventoryDetailId: this.selectValue.inventoryDetailId,
        drugId: this.selectValue.drugId,
        sellPrice: this.selectValue.sellPrice,
        inventoryId: this.selectValue.inventoryId,
        ExpireDate: this.calendarService.ToGregorian(
          this.selectValue.expireDate
        ),
        stockId: this.thisWarehouseHandling?.stockId,
      };

      const thisUrl = `WarehouseHandling/WarehouseHandlingDetail/Submit`;

      this.modalLoading = true;
      this.apiService
        .postItem(new ApiRequestModel(thisUrl, backEndJson))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.modalSuccessConfirm = true;
              this.getSingleData();
              this.clearSelect();
              this.activeMinus = false;
              if (this.data != null) {
                const thisValue = this.data.data.findIndex(
                  (current) => current.warehouseHandlingCount == 0
                );
                const nextValue = this.data.data[thisValue + 1];
                if (nextValue) {
                  this.fastCounter = false;
                  this.valueList = [];
                  this.selectValue = new ImportWarehouseHandlingDetailModal(
                    nextValue
                  );
                  this.modalLoading = false;
                  return;
                }
              }

              this.modalService.dismissAll();

              const barcodeInput = document.getElementById('drug-barcode');

              if (barcodeInput != null) {
                barcodeInput.focus();
              }
            } else {
            }
            this.modalLoading = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.modalLoading = false;
          },
          () => {}
        );
    } catch (error) {
      this.logger.addError(error, false);
    }
  }

  public checkValidationCount(): boolean {
    if (this.selectValue == null) {
      return false;
    }

    if (
      this.selectValue.warehouseHandlingCount == null &&
      this.selectValue.countingDrugPackage == null
    ) {
      return false;
    }

    if (this.selectValue.warehouseHandlingCount == null) {
      this.selectValue.warehouseHandlingCount = 0;
    }

    if (this.selectValue.warehouseHandlingCount < 0) {
      this.selectValue.warehouseHandlingCount = 0;
    }

    if (this.selectValue.countingDrugPackage == null) {
      this.selectValue.countingDrugPackage = 0;
    }

    if (this.selectValue.countingDrugPackage < 0) {
      this.selectValue.countingDrugPackage = 0;
    }

    return true;
  }

  public packageKeyUp() {
    if (this.selectValue == null) {
      return;
    }

    if (!this.checkValidationCount()) {
      return;
    }

    this.selectValue.warehouseHandlingCount =
      this.selectValue.countingDrugPackage * this.selectValue.drugPackageCount;
    this.calcCounting(true);
  }

  public countKeyUp(): boolean {
    if (this.selectValue == null) {
      return false;
    }
    if (!this.checkValidationCount()) {
      return false;
    }

    if (
      this.selectValue.warehouseHandlingCount! %
        this.selectValue.drugPackageCount! !=
      0
    ) {
      if (this.alarmMessage == ``) {
        this.alarmMessage = `مغایرت در بسته بندی`;
      }
      this.calcCounting(true);
      return false;
    } else {
      this.selectValue.drugPackageCount =
        this.selectValue.warehouseHandlingCount! /
        this.selectValue.drugPackageCount!;
      this.calcCounting(true);
      return true;
    }
  }

  public finishingWarehouseHandling() {
    try {
      if (this.thisWarehouseHandling == null) {
        this.logger.addError('خطایی رخ داده است صفحه را به روز نمایید ', false);
        return;
      }

      const thisUrl = `WarehouseHandling/Completion/${this.thisWarehouseHandling.stockId}`;

      this.apiService.getAll(new ApiRequestModel(thisUrl)).subscribe(
        (result) => {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            result,
            `postItem`
          );
          if (result.succeeded) {
            this.modalDeleteConfirm = false;
            this.modalSuccessConfirm = true;
            this.outputParentAction.next(
              new PCTableOutputModel('Return', undefined)
            );
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.modalDeleteConfirm = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.modalDeleteConfirm = false;
        },
        () => {}
      );
    } catch (error) {
      this.logger.addError(error, false);
      this.modalDeleteConfirm = false;
    }
  }

  public SetWithBarcode() {
    const barcode = this.selectValue!.expireDate;
    const expireDate = this.barcodeService.ToExpireDate(barcode);
    const lot = this.barcodeService.ToExpireDate(barcode);
    if (expireDate != null) {
      this.selectValue!.expireDate = expireDate;
    }
  }

  openCollapseJS() {
    const el = document.getElementById('drugCollapseSection');
    if (!el) return;
    this.collapseInstance =
      this.collapseInstance || new bootstrap.Collapse(el, { toggle: false });
    this.isCollapseShown = true;
    this.collapseInstance.show();
  }

  closeCollapseJS() {
    const el = document.getElementById('drugCollapseSection');
    if (!el) return;
    this.collapseInstance =
      this.collapseInstance || new bootstrap.Collapse(el, { toggle: false });
    this.isCollapseShown = false;
    this.collapseInstance.hide();
  }
}
